import React from 'react';

const DraggableDynamicForm = () => <div>Draggable form</div>;
export default DraggableDynamicForm;
